export default __webpack_public_path__ + "static/media/logo-comprobante.e06cf604.svg";